module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/babel-runtime/core-js/object/keys.js
 ** module id = 218
 ** module chunks = 0
 **/